import React from 'react';
import { isImageAssetVideo } from 'core/utils/helpers/checkIfImageAssetVideo';
import AutomaticVideoPlayer from 'core/modules/AutomaticVideoPlayer/AutomaticVideoPlayer';

function VideoOrImageContent({ dataItem }) {
  const { dealId, assets, id } = dataItem;
  const { imageAlternateText, image, shortSummaryText } = assets;

  const imageIsVideo = isImageAssetVideo(image);
  const videoId = `mn_videoSimpleBanner${dealId || id}`;

  return (
    <div className="mn_videoImageContainer">
      {imageIsVideo ?
        <AutomaticVideoPlayer id={videoId} className="mn_bannerVideo" src={image} alt={imageAlternateText} /> :
        <img className="mn_bannerImage" src={image} alt={imageAlternateText} data-test="banner-image" />
      }
      {shortSummaryText && <div className="mn_bannerMobileText">{shortSummaryText}</div>}
    </div>
  );
}

export default VideoOrImageContent;
